import { render, staticRenderFns } from "./DeliveryDestination.vue?vue&type=template&id=c0ab0832&"
import script from "./DeliveryDestination.vue?vue&type=script&lang=js&"
export * from "./DeliveryDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports